import { render, staticRenderFns } from "./shopContainer.vue?vue&type=template&id=37a33584&scoped=true&"
import script from "./shopContainer.vue?vue&type=script&lang=js&"
export * from "./shopContainer.vue?vue&type=script&lang=js&"
import style0 from "./shopContainer.vue?vue&type=style&index=0&id=37a33584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a33584",
  null
  
)

export default component.exports